export default "__VITE_ASSET__oHfZ7ObF__"